import trackingEventDictionary from "@core/dictionary/tracking-event";
import { searchPhraseDictionary } from "@core/global/global-country-dictionary";
import { useState, useEffect } from "react";
import { PillColor, suggestionsKeyLabel } from "./const";
import { globalPendoEventForCompanyRedirection } from "@core/global/global-country-functions";

const AllCategoryAutoSuggest = ({ loading, filteredSuggestions, showSuggestions, setShowSuggestions, setInputValue, inputValue, setSelectedData, selectedData, setSelectedCategory, setIsSelectedFromAutoSuggest, setRedirectionId, redirectionId, dropdownOptions, isRedirect, currentUserPlan, analyticsCountryID }) => {
  const [sliceIndex, setSliceIndex] = useState({});
  const suggestionList = Object.keys(suggestionsKeyLabel);
  const selectedSuggestionPlaceholder = (data) => {
    return dropdownOptions?.find((option) => option.value === data)?.placeHolder ?? "";
  };
  useEffect(() => {
    mapSliceIndex();
  }, [filteredSuggestions]);

  const handleSuggestionClick = (suggestion, key) => {
    if (key === searchPhraseDictionary.product_hscode) {
      setSelectedData([...selectedData, { label: suggestion, value: suggestion.split("-")[0].split(":")[1].trim() }]);
    } else if (key === searchPhraseDictionary.chemical_description) {
      setSelectedData([...selectedData, { label: suggestion.label, value: `${suggestion.label}|${suggestion.value}` }]);
    } else setSelectedData([...selectedData, suggestion]);
    setInputValue("");
    setShowSuggestions(false);
    setSelectedCategory({ value: key, label: suggestionsKeyLabel[key], placeHolder: selectedSuggestionPlaceholder(key) });
  };
  const mapSliceIndex = () => {
    if (suggestionList && suggestionList.length) {
      let tempObj = { ...sliceIndex };
      suggestionList.forEach((item) => (tempObj[item] = 3));
      setSliceIndex(tempObj);
    }
  };

  const showMore = (e, key) => {
    let tempObj = { ...sliceIndex };
    tempObj[key] = tempObj[key] + 3;
    setSliceIndex(tempObj);
    e.stopPropagation();
    // ::Tracking: Below code is for the Tracking of the Search Button Event
    let temp;
    if (key === searchPhraseDictionary.chemical_description) {
      temp = trackingEventDictionary.moreChemicalSuggestion;
    } else if (key === searchPhraseDictionary.product_description) {
      temp = trackingEventDictionary.moreProductSuggestion;
    } else if (key === searchPhraseDictionary.exporters) {
      temp = trackingEventDictionary.moreShipperSuggestion;
    } else if (key === searchPhraseDictionary.importers) {
      temp = trackingEventDictionary.moreConsigneeSuggestion;
    } else if (key === searchPhraseDictionary.ports) {
      temp = trackingEventDictionary.morePortsSuggestion;
    } else if (key === searchPhraseDictionary.logistics) {
      temp = trackingEventDictionary.moreLogisticsSuggestion;
    }
    globalPendoEventForCompanyRedirection(temp, isRedirect, redirectionId, analyticsCountryID, window.location.pathname, currentUserPlan);
    // End of the above code
  };

  const highlightMatch = (text, search) => {
    if (!search) return text;
    const searchedText = escapeRegExp(search);
    const regex = new RegExp(`(${searchedText})`, "gi");
    return text.split(regex).map((part, index) =>
      regex.test(part) ? (
        <mark key={index} className="tw-font-medium tw-bg-transparent tw-p-0">
          {part}
        </mark>
      ) : (
        part
      )
    );
  };
  function escapeRegExp(string = "") {
    return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }
  return (
    ((showSuggestions && Object.keys(filteredSuggestions || {}).length >= 0 && Object.keys(sliceIndex || {}).length > 0) || selectedData.length > 0) && (
      <div className={`tw-absolute tw-top-[85px] tw-z-10 tw-flex tw-items-center tw-bg-white tw-shadow-autoSuggest tw-rounded-2xl ${showSuggestions && Object.keys(sliceIndex || {}).length > 0 && selectedData.length > 0 ? "tw-py-2" : "tw-py-0"}`}>
        <div className="tw-w-[600px] tw-max-h-[300px] tw-overflow-y-auto">
          {loading && Object.values(filteredSuggestions || {}).every((item) => item.length === 0) && inputValue !== "" && <span className="tw-text-sm tw-text-gray-900 tw-font-medium tw-px-3">Loading...</span>}
          {Object?.entries(filteredSuggestions || {}).map(
            ([key, suggestion]) =>
              suggestion.length > 0 && (
                <div key={key} className=" tw-py-1.5 tw-text-sm tw-cursor-pointer">
                  <div className="tw-flex tw-items-center tw-gap-1 tw-px-3">
                    <div className="tw-w-4 tw-h-4 tw-rounded-lg tw-px-1 tw-text-xs tw-text-white" style={{ backgroundColor: PillColor[key] }}>
                      {suggestionsKeyLabel[key]?.substring(0, 1)?.toUpperCase()}
                    </div>
                    <span className="tw-font-semibold tw-text-xs tw-text-gray-900 tw-uppercase">{suggestionsKeyLabel[key]} </span>
                    <span className=" tw-text-xs tw-text-gray-500">found</span>
                    <span className=" tw-text-xs tw-text-gray-900 tw-font-medium tw-px-1.5 tw-bg-gray-200 tw-rounded">{suggestion?.length}</span>
                  </div>
                  <div className="tw-flex tw-flex-col tw-py-1.5">
                    {suggestion?.slice(0, sliceIndex[key])?.map((data) => (
                      <div
                        key={`${key}-${data?.mongo_id || data?.label || data}`}
                        onClick={() => {
                          handleSuggestionClick(data, key);
                          if (data?.mongo_id) {
                            let redirectionIdCopy = { ...redirectionId };
                            redirectionIdCopy[data.label] = data?.mongo_id;
                            setRedirectionId(redirectionIdCopy);
                          } else if (key === searchPhraseDictionary.product_hscode) {
                            let tempData = "";
                            tempData = tempData?.split("-")[0]?.split(":")[1]?.trim();
                            let redirectionIdCopy = { ...redirectionId };
                            redirectionIdCopy[tempData] = tempData;
                            setRedirectionId(redirectionIdCopy);
                          }
                          setIsSelectedFromAutoSuggest(true);
                        }}
                        className="tw-px-3 tw-py-1 tw-text-sm hover:tw-bg-primary-purple-50 tw-cursor-pointer">
                        {key === searchPhraseDictionary.product_hscode ? highlightMatch(data, inputValue) : highlightMatch(data?.label, inputValue)}
                      </div>
                    ))}
                    {suggestion.length > sliceIndex[key] ? (
                      <span className="tw-px-3 tw-py-1 tw-text-xs tw-font-medium tw-text-primary-purple-600" onClick={(e) => showMore(e, key)}>
                        More {suggestionsKeyLabel[key].toLowerCase()} suggestions
                      </span>
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
              )
          )}
          {Object.values(filteredSuggestions || {}).every((item) => item.length === 0) && !loading && inputValue !== "" && <span className="tw-text-sm tw-text-gray-900 tw-font-medium tw-px-3">No results found</span>}
        </div>
      </div>
    )
  );
};

export default AllCategoryAutoSuggest;
